import * as userAvatars from './user-avatars';
import * as aiAvatars from './ai-avatars';

const AVATARS = { ...userAvatars, ...aiAvatars };

export default AVATARS;
